import { useQuery, useMutation, useQueryClient } from 'react-query';
import { UserHttpService } from 'core/services/user';

const useSkills = (cvId = null) => {
    const queryClient = useQueryClient();

    // Query for fetching skills
    const { data, isLoading, error } = useQuery(['skills', cvId], async () => {
        const response = await UserHttpService.listSkills(cvId);
        return response.results || [];
    });

    // Mutation for adding a skill
    const addSkillMutation = useMutation(
        async (newSkill) => {
            return await UserHttpService.addSkill(newSkill);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch skills query
                queryClient.invalidateQueries(['skills', cvId]);
            }
        }
    );

    // Mutation for updating a skill
    const updateSkillMutation = useMutation(
        async (updatedSkill) => {
            return await UserHttpService.updateSkill(updatedSkill);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch skills query
                queryClient.invalidateQueries(['skills', cvId]);
            }
        }
    );

    // Mutation for deleting a skill
    const deleteSkillMutation = useMutation(
        async (id) => {
            return await UserHttpService.deleteSkill(id);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch skills query
                queryClient.invalidateQueries(['skills', cvId]);
            }
        }
    );

    return {
        skills: data || [],
        isLoading,
        error: error ? error.message : null,
        addSkill: addSkillMutation.mutateAsync,
        updateSkill: updateSkillMutation.mutateAsync,
        deleteSkill: deleteSkillMutation.mutateAsync
    };
};

export default useSkills; 